import { render } from "./DownloadStartedPanel.vue?vue&type=template&id=4535324c"
import script from "./DownloadStartedPanel.vue?vue&type=script&lang=js"
export * from "./DownloadStartedPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__